export default __webpack_public_path__ + "images/f83a9f7172cec51322121ce68e69af86-singersongwriter_small.webp";